import { Star } from "lucide-react"

interface Review {
    name: string
    date: string
    room: string
    rating: number
    comment: string
}

// ─── Mock data ───────────────────────────────────────────────────
const REVIEWS: Review[] = [
    { name: "Trà Sữa Trân Châu", date: "00/00/2026", room: "Nhà Cam", rating: 5, comment: "Home rất là Home" },
    { name: "PhúcPhen", date: "00/00/2026", room: "Nhà Cam", rating: 5, comment: "Châu Âu Châu Phi sao bằng Trà Sữa Trân Châu" },
    { name: "Trà Sữa Trân Châu", date: "00/00/2026", room: "Nhà Cam", rating: 5, comment: "Home rất là Home" },
    { name: "Nguyễn Thu Hà", date: "14/02/2026", room: "BB's Canvas", rating: 5, comment: "Trải nghiệm tuyệt vời! Phòng trang trí rất xinh, nhân viên thân thiện." },
    { name: "Đặng Thị Hoa", date: "12/02/2026", room: "BB's 52Hz", rating: 5, comment: "Lần đầu đến mà ấn tượng lắm, phòng sạch sẽ thơm tho, sẽ giới thiệu bạn bè." },
    { name: "Trần Thị Bích", date: "12/02/2026", room: "BB's Cherry", rating: 5, comment: "Lần đầu đến mà ấn tượng lắm, phòng sạch sẽ thơm tho, sẽ giới thiệu bạn bè." },
]

const OVERALL_RATING = 4.4
const TOTAL_REVIEWS = 55

/** Lấy 2 chữ cái viết tắt từ tên */
function initials(name: string): string {
    const words = name.trim().split(/\s+/)
    if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase()
    return name.slice(0, 2).toUpperCase()
}

function StarRating({ rating, size = "sm" }: { rating: number; size?: "sm" | "md" }) {
    const cls = size === "md" ? "h-4 w-4" : "h-3.5 w-3.5"
    return (
        <div className="flex items-center gap-0.5">
            {Array.from({ length: 5 }).map((_, i) => (
                <Star
                    key={i}
                    className={cls}
                    fill={i < Math.round(rating) ? "#F5B301" : "none"}
                    stroke={i < Math.round(rating) ? "#F5B301" : "#D9C9A8"}
                    strokeWidth={1.5}
                />
            ))}
        </div>
    )
}

export function ReviewsSection({ id }: { id?: string }) {
    return (
        <section id={id} className="scroll-mt-24 bg-[#fffcf7] px-4 py-14 sm:px-8 lg:py-20">
            <div className="mx-auto max-w-[1160px]">
                {/* Header */}
                <div className="mb-10 text-center">
                    <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#b9895c]">
                        Đánh giá
                    </p>
                    <h2 className="font-display mt-2 text-3xl font-bold text-[#2b2620] sm:text-[38px]">
                        Khách hàng nói gì về chúng tôi
                    </h2>
                    <div className="mt-3 flex items-center justify-center gap-2">
                        <StarRating rating={OVERALL_RATING} size="md" />
                        <span className="text-base font-bold text-[#2b2620]">{OVERALL_RATING}</span>
                        <span className="text-sm text-[#9b8b7a]">({TOTAL_REVIEWS} đánh giá)</span>
                    </div>
                </div>

                {/* Grid reviews */}
                <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
                    {REVIEWS.map((r, i) => (
                        <div
                            key={r.name + i}
                            className="rounded-2xl border border-[#f0e9db] bg-white p-5 shadow-[0_4px_16px_rgba(67,52,39,0.05)]"
                        >
                            {/* Avatar + info */}
                            <div className="flex items-center gap-3">
                                <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-[#efe7d8] text-xs font-bold text-[#8a8175]">
                                    {initials(r.name)}
                                </div>
                                <div className="min-w-0">
                                    <p className="truncate text-sm font-bold text-[#2b2620]">{r.name}</p>
                                    <p className="truncate text-xs text-[#9b8b7a]">{r.date} {r.room}</p>
                                </div>
                            </div>

                            {/* Stars */}
                            <div className="mt-3">
                                <StarRating rating={r.rating} />
                            </div>

                            {/* Comment */}
                            <p className="mt-2 text-sm leading-relaxed text-[#5f574c]">{r.comment}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
